"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forScreenReader = exports["default"] = exports.centerContents = void 0;
exports.media = media;
exports.standardShadow = exports.normaliseButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Shared partial styles
// Destructure into other styles

var forScreenReader = exports.forScreenReader = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px'
};
var standardShadow = exports.standardShadow = {
  boxShadow: '2px 2px 10px #aaa'
};
var centerContents = exports.centerContents = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
var normaliseButton = exports.normaliseButton = {
  background: 'none',
  border: 'none',
  boxShadow: 'none'
};

// Shared complete styles
// Import and use as classes
var _default = exports["default"] = (0, _nano.sheet)({
  controlContainer: {
    flex: 1,
    padding: '5px',
    minHeight: '35px',
    maxHeight: '40px',
    boxSizing: 'content-box',
    '& select': {
      width: '100%'
    },
    "input[type='text'],  input[type='number'],  input[type='date'],  input[type='url']": {
      width: '100%',
      boxSizing: 'border-box'
    },
    '> button': {
      maxHeight: '32px',
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  }
});
var screenXS = 480;
var screenSM = 768;
var screenMD = 992;
var screenLG = 1200;

// Prevent overlapping
var screenXXSMax = screenXS - 1;
var screenXSMax = screenSM - 1;
var screenSMMax = screenMD - 1;
var screenMDMax = screenLG - 1;
var mediaSizes = new Map([['xss', "@media (max-width: ".concat(screenXXSMax, "px)")], ['xs', " @media (min-width: ".concat(screenXS, "px) and (max-width: ").concat(screenXSMax, "px)")], ['sm', "@media (min-width: ".concat(screenSM, "px) and (max-width: ").concat(screenSMMax, "px)")], ['md', "@media (min-width: ".concat(screenMD, "px) and (max-width: ").concat(screenMDMax, "px)")], ['lg', "@media (min-width: ".concat(screenLG, "px)")]]);
function media(sizes, styles) {
  return sizes.reduce(function (p, size) {
    var key = mediaSizes.get(size);
    return _objectSpread(_objectSpread({}, p), {}, (0, _defineProperty2["default"])({}, key, styles));
  }, {});
}